export default "__VITE_ASSET__a1d8694f__"